import Box from '@eversports/klimt-primitives/legacy/Box'
import * as React from 'react'

interface Props {
  forwardedRef?: React.MutableRefObject<null>
  onClick?: () => void
}

const MatchSettingParticipantBox = ({ children, forwardedRef, onClick }: React.PropsWithChildren<Props>) => {
  return (
    <Box
      width="fit-content"
      flex={[1, 'initial']}
      ref={forwardedRef}
      onClick={onClick}
      sx={{
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'mediumgray',
        borderRadius: 1,
        cursor: 'pointer',
        position: 'relative',
        textAlign: 'center',
        minWidth: 100,
        maxWidth: 150,
        py: 1,
        px: 2,
      }}
    >
      {children}
    </Box>
  )
}

export default MatchSettingParticipantBox
